module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M32 2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v28a2 2 0 0 0 2 2h28a2 2 0 0 0 2-2V2zM8.016 5a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2zm13.7 15.878a1 1 0 0 1 0 1.414l-1.414 1.414a1 1 0 0 1-1.414 0l-2.878-2.878-2.868 2.868a1 1 0 0 1-1.414 0l-1.414-1.414a1 1 0 0 1 0-1.414L13.182 18l-2.868-2.868a1 1 0 0 1 0-1.414l1.414-1.414a1 1 0 0 1 1.414 0l2.868 2.868 2.878-2.878a1 1 0 0 1 1.414 0l1.414 1.414a1 1 0 0 1 0 1.414L18.838 18l2.878 2.878z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/close-browser-2.js
// module id = 1069
// module chunks = 14